export default __webpack_public_path__ + "static/media/collaborate4.f9e8175d.png";